import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CostPriceIngredient } from '../../../../services/costPrice/costPriceService';
import { useOrderHistory } from '../../../../stores/appOrderHistoryStore';
import { useCostPriceStore } from '../../../../stores/appCostPriceStore';
import { useSubrecipesStore } from '../../../../stores/appSubrecipesStore';
import { useLoadOrderHistory } from '../../../../utils/dataLoadingUtils';
import { secondaryText } from '../../../../styling/stylingHelper';
import SwapIngredientPanel from '../review/SwapIngredientPanel';
import { createAutomationRunSwap } from './automationRunSwap';

type Props = {
  restaurantId: string; runId: string; dishId: string; row: CostPriceIngredient;
  write: (dishId: string, operation: () => Promise<void>) => Promise<void>;
  onDone: () => void;
};

export default function AutomationSwapPanel({ restaurantId, runId, dishId, row, write, onDone }: Props) {
  const { t } = useTranslation();
  useLoadOrderHistory();
  const orders = useOrderHistory();
  const customs = useCostPriceStore(state => state.customIngredients);
  const customsRestaurantId = useCostPriceStore(state => state.customIngredientsRestaurantId);
  const subrecipes = useSubrecipesStore(state => state.subrecipesById);
  const subrecipesRestaurantId = useSubrecipesStore(state => state.currentRestaurantId);
  const [saving, setSaving] = useState(false);
  // Keep the original identity through the first save and the bulk-apply step.
  const [{ ingredient, adapter }] = useState(() => createAutomationRunSwap(restaurantId, runId, row,
    async (id, operation) => {
      setSaving(true);
      try { await write(id, operation); } finally { setSaving(false); }
    }));
  const ready = orders.currentRestaurantId === restaurantId && !orders.isLoading;
  return <div className="mt-2">
    <button type="button" disabled={saving} onClick={onDone} className={`min-h-[44px] text-sm ${secondaryText}`}>
      {t('common.close')}
    </button>
    {ready ? <SwapIngredientPanel ingredient={ingredient} ingredientIndex={0} itemId={dishId}
      adapter={adapter} productMatching requireQuantityOnUnitChange defaultWastePercentage={0} onDone={onDone}
      dataOverride={{ orders: orders.orderHistoryList, customIngredients: customsRestaurantId === restaurantId ? customs.filter(custom => custom.restaurantId === restaurantId) : [],
        subrecipes: subrecipesRestaurantId === restaurantId ? new Map(Array.from(subrecipes).filter(([, sub]) => sub.restaurantId === restaurantId)) : new Map() }} />
      : <p className={secondaryText}>{t('common.loading')}</p>}
  </div>;
}
